<template>
    <div>
        <div class="p-grid">
            <div class="p-col-12 ">
                <div class="card">
                    <Toolbar>
                        <template #left>
                            <Link href="/paket_pengadaan/create"><Button label="Tambah Paket Pengadaan" icon="pi pi-plus" class="mr-2" /></Link>
                        </template>
                    </Toolbar>
                </div>
            </div>
            <div class="p-col-12">
                <div class="card">
                    <DataTable ref="dt" :value="datatable.data" :lazy="true" data-key="id" :paginator="true" :rows="10" :loading="datatable.loading" :total-records="datatable.totalRecords" filter-display="menu" :global-filter-fields="datatable.globalFilterFields" v-model:filters="datatable.filters" paginator-template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" :rows-per-page-options="[5, 10, 25]" current-page-report-template="Menampilkan data ke {first} sampai {last} dari total {totalRecords} data" @page="onPage($event)" @sort="onSort($event)" @filter="onFilter()">
                        <template #header>
                            <div class="table-header">
                                <h5 class="p-m-0 text-center">
                                    Daftar Paket Pengadaan
                                </h5>
                                <div class="flex justify-content-between">
                                    <Button type="button" icon="pi pi-filter-slash" label="Clear" class="p-button-outlined" @click="clearFilter()" />
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search" />
                                        <InputText v-model="datatable.filters['global'].value" @keydown.enter="onFilter()" placeholder="Keyword Search" />
                                    </span>
                                </div>
                            </div>
                        </template>
                        <Column field="id" header="ID" :sortable="false">
                            <template #body="slotProps">
                                {{ slotProps.data.number }}
                            </template>
                        </Column>
                        <Column field="nama_paket_pengadaan" header="Nama Paket" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.nama_paket_pengadaan }}
                            </template>
                        </Column>
                        <Column field="pagu" header="Pagu Anggaran" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.pagu_anggaran }}
                            </template>
                        </Column>
                        <Column field="status" header="Status" :sortable="true">
                            <template #body="slotProps">
                                {{ slotProps.data.status }}
                            </template>
                        </Column>
                        <Column header="Aksi" style="width: 150px;">
                            <template #body="slotProps">
                                <Button class="p-button-info p-button-sm mr-1"
                                    @click="edit(slotProps.data.id)" v-if="slotProps.data.can.update" label="Pilih Paket"/>
                                <Button v-if="isAuthorized" icon="pi pi-trash" class="p-button-sm p-button-danger"
                                    @click="showDeleteDialog(slotProps.data)" />
                            </template>
                        </Column>
                        <template #empty>
                            Belum ada Data!
                        </template>
                    </DataTable>
                </div>
            </div>
        </div>

        <DeleteDialog ref="deleteDialog" v-model:visible="deleteDialog" :loading="deletingModel" @delete="onDelete" />
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import { FilterMatchMode } from "primevue/api";
import DatatableService from "../../Services/DatatableService";
import Menubar from "primevue/menubar";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import DeleteDialog from "../../Components/DeleteDialog";
import Toolbar from "primevue/toolbar";
import { Link } from '@inertiajs/inertia-vue3'

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        DataTable,
        Column,
        Button,
        DeleteDialog,
        Toolbar,
        Link,
        InputText
    },
    data() {
        return {
            datatable: {
                loading: true,
                totalRecords: 0,
                data: null,
                filters: {
                    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                    // 'status': { value: null, matchMode: FilterMatchMode.EQUALS },
                },
                lazyParams: {}
            },
            importDialog: false,
            importForm: this.$inertia.form({
                file: null
            }),
            selectedModel: null,
            deleteDialog: false,
            deletingModel: false,
            isAuthorized: false,
        }
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
    },
    mounted() {
        this.datatable.loading = true;
        this.datatable.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: 'id',
            sortOrder: -1,
            filters: this.datatable.filters,
            globalFilterFields: this.datatable.globalFilterFields
        };
        this.loadLazyData();
    },
    methods: {
        loadLazyData() {
            this.datatable.loading = true;
            try {
                const res = axios.get(route('/paket_pengadaan/datatable'), {
                    params: {
                        dt_params: JSON.stringify(this.datatable.lazyParams),
                        searchable_columns: JSON.stringify(this.datatable.globalFilterFields),
                    },
                });

                this.datatable.data = res.data.payload.data;
                this.datatable.totalRecords = res.data.payload.total;
                this.datatable.loading = false;
            } catch (e) {
                this.datatable.loading = false;

                this.datatable.data = [];
                this.datatable.totalRecords = 0;
                // loading.value = false;
            }
            this.datatable.loading = true;
            this.datatableService.getData(this.route('paket_pengadaan.datatable'), {
                dt_params: JSON.stringify(this.datatable.lazyParams),
                searchable_columns: JSON.stringify(this.datatable.globalFilterFields)

            }).then(data => {
                this.datatable.data = data.payload.data;
                this.datatable.totalRecords = data.payload.total;
                this.datatable.loading = false;
            });
        },
        onFilter() {
            this.datatable.lazyParams.filters = this.datatable.filters;
            this.loadLazyData();
            // this.datatable.lazyParams.filters = this.datatable.filters;
            // console.log('huehue');
            // this.loadLazyData();
        },
        clearFilter() {
            this.datatable.filters =
            {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                // 'status': {value: null, matchMode: FilterMatchMode.EQUALS},
            };

            this.datatable.lazyParams.filters = this.datatable.filters;
            this.loadLazyData();
        },
        onPage(event) {
            this.datatable.lazyParams = event;
            this.loadLazyData();
            // this.datatable.lazyParams = {
            //     globalFilterFields : this.datatable.lazyParams.globalFilterFields,
            //     ...event
            // };
            // console.log(this.datatable.lazyParams);
            // this.loadLazyData();
        },
        onSort(event) {
            // console.log(event);
            this.datatable.lazyParams = event;
            this.loadLazyData();
            // this.datatable.lazyParams = {
            //     globalFilterFields : this.datatable.lazyParams.globalFilterFields,
            //     ...event
            // };
            // this.loadLazyData();
        },
        edit(id) {
            this.$inertia.visit(this.route('paket_pengadaan.edit', id), { preserveScroll: true });
        },
        showDeleteDialog(model) {
            this.selectedModel = model;
            this.deleteDialog = true;
        },
        onDelete() {
            this.deletingModel = true;
            this.$inertia.delete(this.route('paket_pengadaan.destroy', this.selectedModel.id), {
                onSuccess: () => {
                    this.deletingModel = false;
                    this.deleteDialog = false;
                    this.loadLazyData();
                    this.$refs.deleteDialog.onClose();
                }
            })
        },
    }
}
</script>

<style scoped></style>
